import { ErrorLevel, setErrorLevelAddOn } from './errorLevelTools';

export function checkPasswortSecurity(password: string, password_confirm?: string) {
    const securityMessages: Array<string> = [];
    const kriterienTest = {
        zahlen: /\d/.test(password),
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        specialchars: /\W|_/.test(password),
        laenge: password.length > 7,
    };
    if (!kriterienTest.zahlen) {
        securityMessages.push('mind. 1 Zahl enthalten');
    }
    if (!kriterienTest.lowercase || !kriterienTest.uppercase) {
        securityMessages.push('Groß- und Kleinschreibung enthalten');
    }
    if (!kriterienTest.specialchars) {
        securityMessages.push('mind. 1 Sonderzeichen enthalten');
    }
    if (!kriterienTest.laenge) {
        securityMessages.push('mind. 8 Zeichen lang sein');
    }
    if (typeof password_confirm === 'string' && password !== password_confirm) {
        securityMessages.push('Eingabe stimmt nicht überein!');
    }
    if (securityMessages.length > 0) {
        return setErrorLevelAddOn(securityMessages.join('; '), ErrorLevel.error);
    }
    return true;
}
